var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketnotification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1171 16.6667C12.7318 18.5658 11.0583 20 9.05844 20C7.05853 20 5.3842 18.5658 4.99979 16.6667H13.1171ZM16.1004 5.83333C17.6993 5.83333 19 4.525 19 2.91667C19 1.30833 17.6993 0 16.1004 0C14.5014 0 13.2008 1.30833 13.2008 2.91667C13.2008 4.525 14.5014 5.83333 16.1004 5.83333ZM16.2992 7.49C16.2329 7.4925 16.1675 7.5 16.1004 7.5C13.5876 7.5 11.5438 5.44417 11.5438 2.91667C11.5438 2.16333 11.7286 1.45333 12.0508 0.825833C11.0716 0.296667 9.95815 0 8.79001 0C5.55818 0 2.76046 2.2575 2.05958 5.43L0.112688 11.7608C-0.381905 13.3692 0.813568 14.9992 2.48706 14.9992H15.4575C17.1807 14.9992 18.3811 13.2783 17.7946 11.6483L16.2984 7.48833L16.2992 7.49Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketnotification);
export default __webpack_public_path__ + "static/media/ticketnotification.e704da97a1041d53913f3e8ffd369add.svg";
export { ForwardRef as ReactComponent };